// import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
// import popup_looking1 from "../../images/popup_looking-1.png";
// import popup_looking2 from "../../images/popup_looking-2.png";
// import popup_looking3 from "../../images/popup_looking-3.png";
// import popup_looking4 from "../../images/popup_looking-4.png";
// import popup_looking5 from "../../images/popup_looking-5.png";
// import Close from "../../images/popup_close-btn.png";
// import popup_about1 from "../../images/popup_about-1.png";
// import popup_about2 from "../../images/popup_about-2.png";
// import popup_about3 from "../../images/popup_about-3.png";
// import popup_social1 from "../../images/popup_social-1.png";
// import popup_social2 from "../../images/popup_social-2.png";
// import popup_social3 from "../../images/popup_social-3.png";

// function SearchPopup() {
//   const closepopup = () => {
//     document.getElementById("popup-box1").style.display = "none";
//   };

//   return (
//     <>
//       <div id="popup-box1" className="popup-position">
//         <div className="search-popup-container">
//           <div className="left">
//             <div className="invest">
//               <p className="head">I want to Invest in</p>
//               <div className="invest-fund">
//                 <div className="funds">
//                   <a
//                     href={
//                       "products/Equity/JM-Flexicap-Fund/J358/(Regular)---Growth-Option"
//                     }
//                   >
//                     JM Flexi Cap Fund
//                   </a>
//                 </div>
//                 <div className="funds">
//                   <a
//                     href={
//                       "/products/Equity/JM-ELSS-Tax-Saver-Fund-(Formerly-known-as-JM-Tax-Gain-Fund)/J282/Regular-Growth-Option"
//                     }
//                   >
//                     JM ELSS Tax Saver Fund
//                   </a>
//                 </div>
//                 <div className="funds">
//                   <a
//                     href={
//                       "products/Equity/JM-Midcap-Fund/J644/(Regular)---Growth-Option"
//                     }
//                   >
//                     JM Midcap Fund
//                   </a>
//                 </div>
//                 <div className="funds">
//                   <a
//                     href={
//                       "products/Equity/JM-Value-Fund/J246/(Regular)---Growth-Option"
//                     }
//                   >
//                     JM Value Fund
//                   </a>
//                 </div>
//                 <div className="funds">
//                   <a
//                     href={
//                       "products/Fixed-Income/JM-Short-Duration-Fund/J638/(Regular)---Growth-Option"
//                     }
//                   >
//                     JM Short Duration Fund
//                   </a>
//                 </div>
//               </div>
//             </div>
//             <div className="looking-section">
//               <div className="looking-for">
//                 <p className="head">What are you looking for?</p>
//                 <div className="looking-container">
//                   <div className="lookings">
//                     <div className="img-container">
//                       <img src={popup_looking1} alt="popup_looking1" />
//                     </div>
//                     <p>
//                       <a href="/downloads/Factsheet">Factsheet</a>
//                     </p>
//                   </div>
//                   <div className="lookings">
//                     <div className="img-container">
//                       <img src={popup_looking2} alt="popup_looking2" />
//                     </div>
//                     <p>
//                       <a href="/NAVs-and-IDCW/">NAV’s & IDCW</a>
//                     </p>
//                   </div>
//                   <div className="lookings">
//                     <div className="img-container">
//                       <img src={popup_looking3} alt="popup_looking3" />
//                     </div>
//                     <p>
//                       <a href="/products">Products</a>
//                     </p>
//                   </div>
//                   <div className="lookings">
//                     <div className="img-container">
//                       <img src={popup_looking4} alt="popup_looking4" />
//                     </div>
//                     <p>
//                       <a href="Calculator/Plan-Wise-Investment">Calculator</a>
//                     </p>
//                   </div>
//                   <div className="lookings">
//                     <div className="img-container">
//                       <img src={popup_looking5} alt="popup_looking5" />
//                     </div>
//                     <p>
//                       <a href="Communication-Center/PressRelease">
//                         Media Center
//                       </a>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="portal-box">
//                 <p>Investor Portal</p>
//                 <p>Distributor Portal</p>
//               </div>
//             </div>
//           </div>
//           <div className="right">
//             <div className="head">
//               <p>I want to know about Partner corner</p>
//             </div>

//             <ul className="partners-container">
//               <li>
//                 <span className="img-container">
//                   <img src={popup_about1} alt="popup-about1" />
//                 </span>
//                 <p>
//                   <a href={"/PartnersCorner"}>Partner Online</a>
//                 </p>
//               </li>
//               <li>
//                 <span className="img-container">
//                   <img src={popup_about2} alt="popup-about2" />
//                 </span>
//                 <p>
//                   <a href={"/PartnersCorner"}>Partner Transaction</a>
//                 </p>
//               </li>
//               <li>
//                 <span className="img-container">
//                   <img src={popup_about3} alt="popup-about3" />
//                 </span>
//                 <p>
//                   <a href={"/PartnersCorner"}>Generate Easy Link</a>
//                 </p>
//               </li>
//             </ul>
//           </div>
//           <div className="top-bar-btns">
//             <ul className="social-icons">
//               <li>
//                 <a
//                   target="_blank"
//                   href="https://www.youtube.com/@JMFinancialAMC/"
//                 >
//                   <img src={popup_social1} alt="popup-social1" />
//                 </a>
//               </li>
//               <li>
//                 <a
//                   target="_blank"
//                   href="https://www.linkedin.com/company/jm-financial-mutual-fund-ltd/mycompany/"
//                 >
//                   <img src={popup_social2}alt="popup-social2" />
//                 </a>
//               </li>
//               <li>
//                 <a
//                   target="_blank"
//                   href="https://www.instagram.com/jmfinancialmutualfund/"
//                 >
//                   <img src={popup_social3} alt="popup-social3" />
//                 </a>
//               </li>
//             </ul>
//             <button className="close-btn-search" aria-label="search popup close button">
//               <img src={Close} alt="" onClick={closepopup} />
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SearchPopup;


import React from 'react';
import popup_looking1 from "../../images/popup_looking-1.png";
import popup_looking2 from "../../images/popup_looking-2.png";
import popup_looking3 from "../../images/popup_looking-3.png";
import popup_looking4 from "../../images/popup_looking-4.png";
import popup_looking5 from "../../images/popup_looking-5.png";
import Close from "../../images/popup_close-btn.png";
import popup_about1 from "../../images/popup_about-1.png";
import popup_about2 from "../../images/popup_about-2.png";
import popup_about3 from "../../images/popup_about-3.png";
import popup_social1 from "../../images/popup_social-1.png";
import popup_social2 from "../../images/popup_social-2.png";
import popup_social3 from "../../images/popup_social-3.png";

function SearchPopup({
  showPop,           // true = show search results, false = show popular
  dataCompt = [],    // Popular searches (GetCompactSearchFund)
  dataSearch = [],   // Search results (GetFundSearch)
  onClose,           // Better way to close popup
}) {

  return (
    <div 
      id="popup-box1" 
      className="popup-position"
      style={{ display: 'block' }}   // Controlled by parent via state
    >
      <div className="search-popup-container">
        
        {/* LEFT SIDE */}
        <div className="left">
          {!showPop ? (
            // === Popular / Default View ===
            <>
              <div className="invest">
                <p className="head">I want to Invest in</p>
                <div className="invest-fund">
                  {dataCompt && dataCompt.length > 0 ? (
                    dataCompt.map((item) => (
                      <div className="funds" key={item.CompactSearchID}>
                        <a href={item.LinkPath || "#"}>
                          {item.SectionName}
                        </a>
                      </div>
                    ))
                  ) : (
                    // Fallback hardcoded (you can remove later)
                    <>
                      <div className="funds"><a href="/products/Equity/JM-Flexicap-Fund/J358/Regular-Plan-Growth-Option">JM Flexi Cap Fund</a></div>
                      <div className="funds"><a href="/products/Equity/JM-ELSS-Tax-Saver-Fund/J282/Regular-Growth-Option">JM ELSS Tax Saver Fund</a></div>
                      <div className="funds"><a href="/products/Equity/JM-Midcap-Fund/J644/Regular-Plan-Growth-Option">JM Midcap Fund</a></div>
                    </>
                  )}
                </div>
              </div>

              {/* Looking For Section */}
              <div className="looking-section">
                <div className="looking-for">
                  <p className="head">What are you looking for?</p>
                  <div className="looking-container">
                    <div className="lookings">
                      <div className="img-container"><img src={popup_looking1} alt="Factsheet" /></div>
                      <p><a href="/downloads/Factsheet">Factsheet</a></p>
                    </div>
                    <div className="lookings">
                      <div className="img-container"><img src={popup_looking2} alt="NAVs" /></div>
                      <p><a href="/NAVs-and-IDCW/">NAV’s & IDCW</a></p>
                    </div>
                    <div className="lookings">
                      <div className="img-container"><img src={popup_looking3} alt="Products" /></div>
                      <p><a href="/products">Products</a></p>
                    </div>
                    <div className="lookings">
                      <div className="img-container"><img src={popup_looking4} alt="Calculator" /></div>
                      <p><a href="Calculator/Plan-Wise-Investment">Calculator</a></p>
                    </div>
                    <div className="lookings">
                      <div className="img-container"><img src={popup_looking5} alt="Media" /></div>
                      <p><a href="Communication-Center/PressRelease">Media Center</a></p>
                    </div>
                  </div>
                </div>

                <div className="portal-box">
                  <p><a href="https://investor.jmfinancialmf.com/jmfinvestor/" target="_blank">Investor Portal</a></p>
                  <p><a href="https://dit.jmfinancialmf.com/portal/login" target="_blank">Distributor Portal</a></p>
                </div>
              </div>
            </>
          ) : (
            // === Search Results View ===
            <div className="fundNew">
              <div className="popupFundSearch">
                {dataSearch && dataSearch.length > 0 ? (
                  dataSearch.map((item, index) => (
                    <div className="popupFund" key={index}>
                      <h2>{item.Title}</h2>
                      {item.Description && <p>{item.Description}</p>}
                      {item.SectionPath && (
                        <a href={item.SectionPath} className="know-more-link">
                          Know More
                        </a>
                      )}
                      <hr />
                    </div>
                  ))
                ) : (
                  <h6 className="errorSearch">No Data Found !!!</h6>
                )}
              </div>
            </div>
          )}
        </div>

        {/* RIGHT SIDE - Partner Corner */}
        <div className="right">
          <div className="head">
            <p>I want to know about Partner corner</p>
          </div>
          <ul className="partners-container">
            <li>
              <span className="img-container"><img src={popup_about1} alt="Partner Online" /></span>
              <p><a href="/PartnersCorner">Partner Online</a></p>
            </li>
            <li>
              <span className="img-container"><img src={popup_about2} alt="Partner Transaction" /></span>
              <p><a href="/PartnersCorner">Partner Transaction</a></p>
            </li>
            <li>
              <span className="img-container"><img src={popup_about3} alt="Generate Easy Link" /></span>
              <p><a href="/PartnersCorner">Generate Easy Link</a></p>
            </li>
          </ul>
        </div>

        {/* Top Right Close Button + Social Icons */}
        <div className="top-bar-btns">
          <ul className="social-icons">
            <li><a target="_blank" href="https://www.youtube.com/@JMFinancialAMC/"><img src={popup_social1} alt="YouTube" /></a></li>
            <li><a target="_blank" href="https://www.linkedin.com/company/jm-financial-mutual-fund-ltd/mycompany/"><img src={popup_social2} alt="LinkedIn" /></a></li>
            <li><a target="_blank" href="https://www.instagram.com/jmfinancialmutualfund/"><img src={popup_social3} alt="Instagram" /></a></li>
          </ul>
          
          <button 
            className="close-btn-search" 
            aria-label="Close search popup"
            onClick={onClose}
          >
            <img src={Close} alt="Close" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default SearchPopup;
